import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Brand } from '@printdeal/ui-library';
import { ValidationAttribute as SelectionValidationAttribute } from '@printdeal/product-selector';
import { ValidationAttribute } from '../../../../../types/selector/Selector';
import { getAttribute } from '../../../selector/helpers/SelectorHelper';

type VersionedValidationAttributes = {
  validationVersion: 0,
  attributes: ValidationAttribute[],
} |
{
  validationVersion: 1,
  attributes: SelectionValidationAttribute[],
};

interface Props {
  productAttributes: VersionedValidationAttributes;
}

type FSC = {
  claim?: string,
  certificate?: string,
};

const getFSCClaim = (productAttributes: VersionedValidationAttributes): FSC => {
  if (productAttributes.validationVersion === 0) {
    const fscClaimAttribute = getAttribute(productAttributes.attributes, 'FSC Claim');
    const fscCertificate = getAttribute(productAttributes.attributes, 'FSC Certificate');

    return {
      claim: fscClaimAttribute?.resolvedValue,
      certificate: fscCertificate?.resolvedValue,
    };
  }

  const fscClaimAttribute = productAttributes.attributes.find(({ key }) => key === 'FSC Claim');
  const fscCertificate = productAttributes.attributes.find(({ key }) => key === 'FSC Certificate');

  return {
    claim: fscClaimAttribute?.resolvedValue,
    certificate: fscCertificate?.resolvedValue,
  };
};

const FSCInfo = ({ productAttributes }: Props) => {
  const fscLicenseNumber = process.env.GATSBY_FSC_LICENSE_NUMBER;
  const { claim, certificate } = getFSCClaim(productAttributes);

  const hasFSC = fscLicenseNumber && claim && certificate;
  if (!hasFSC || claim === 'None' || certificate === 'None') {
    return null;
  }

  return (
    <div className="pd-my-5 pd-flex pd-items-center pd-text-dim-500">
      <Brand brand="fsc" className="pd-mr-3 pd-h-12" />
      <FormattedMessage
        id="productDetail.fscInfo"
        defaultMessage="FSC® {licenseNumber} / {claim} [{certificate}]"
        values={{
          licenseNumber: fscLicenseNumber,
          claim,
          certificate,
        }}
      />
    </div>
  );
};

export default FSCInfo;
